import React from "react";

import { styled } from "sharedUI/styles";

interface Props {
    active?: boolean;
    label: string;
    onClick?(ev: React.MouseEvent): void;
    count?: number;
    icon: keyof typeof icons;
}

interface StyleProps {
    active: boolean;
}

export const icons = {
    apps: (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M1.3999 4.80001C1.3999 3.68543 1.3999 3.12815 1.61081 2.70605C1.8044 2.31862 2.11852 2.0045 2.50595 1.81092C2.92804 1.60001 3.48533 1.60001 4.5999 1.60001C5.43583 1.60001 5.8538 1.60001 6.17037 1.75819C6.46094 1.90338 6.69653 2.13897 6.84172 2.42954C6.9999 2.74611 6.9999 3.15908 6.9999 3.98501V4.81501C6.9999 5.64094 6.9999 6.0539 6.84172 6.37047C6.69653 6.66104 6.46094 6.89663 6.17037 7.04182C5.8538 7.20001 5.44083 7.20001 4.6149 7.20001H3.7849C2.95897 7.20001 2.54601 7.20001 2.22943 7.04182C1.93886 6.89663 1.70328 6.66104 1.55809 6.37047C1.3999 6.0539 1.3999 5.63594 1.3999 4.80001Z"
                fill="currentColor"
            />
            <path
                opacity="0.65"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.00263 3.985C9.00263 3.15908 9.00263 2.74611 9.16082 2.42954C9.30601 2.13897 9.5416 1.90338 9.83217 1.75819C10.1487 1.60001 10.5667 1.60001 11.4026 1.60001C12.5172 1.60001 13.0745 1.60001 13.4966 1.81092C13.884 2.0045 14.1981 2.31862 14.3917 2.70605C14.6026 3.12815 14.6026 3.68543 14.6026 4.80001C14.6026 5.63594 14.6026 6.0539 14.4445 6.37047C14.2993 6.66105 14.0637 6.89663 13.7731 7.04182C13.4565 7.20001 13.0436 7.20001 12.2176 7.20001H11.3876C10.5617 7.20001 10.1487 7.20001 9.83217 7.04182C9.5416 6.89663 9.30601 6.66105 9.16082 6.37047C9.00263 6.0539 9.00263 5.64094 9.00263 4.81501V3.985ZM1.3999 11.2C1.3999 10.3641 1.3999 9.94612 1.55809 9.62955C1.70328 9.33898 1.93886 9.10339 2.22943 8.9582C2.54601 8.80002 2.95897 8.80002 3.7849 8.80002H4.6149C5.44083 8.80002 5.8538 8.80002 6.17037 8.9582C6.46094 9.10339 6.69653 9.33898 6.84172 9.62955C6.9999 9.94612 6.9999 10.3591 6.9999 11.185V12.015C6.9999 12.8409 6.9999 13.2539 6.84172 13.5705C6.69653 13.8611 6.46094 14.0966 6.17037 14.2418C5.8538 14.4 5.43583 14.4 4.5999 14.4C3.48533 14.4 2.92804 14.4 2.50595 14.1891C2.11852 13.9955 1.8044 13.6814 1.61081 13.294C1.3999 12.8719 1.3999 12.3146 1.3999 11.2ZM9.16082 9.62954C9.00263 9.94611 9.00263 10.3591 9.00263 11.185V12.015C9.00263 12.8409 9.00263 13.2539 9.16082 13.5705C9.30601 13.861 9.5416 14.0966 9.83217 14.2418C10.1487 14.4 10.5667 14.4 11.4026 14.4C12.5172 14.4 13.0745 14.4 13.4966 14.1891C13.884 13.9955 14.1981 13.6814 14.3917 13.294C14.6026 12.8719 14.6026 12.3146 14.6026 11.2C14.6026 10.3641 14.6026 9.94611 14.4445 9.62954C14.2993 9.33897 14.0637 9.10338 13.7731 8.95819C13.4565 8.80001 13.0436 8.80001 12.2176 8.80001H11.3876C10.5617 8.80001 10.1487 8.80001 9.83217 8.95819C9.5416 9.10338 9.30601 9.33897 9.16082 9.62954Z"
                fill="currentColor"
            />
        </svg>
    ),
    billing: (
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect opacity="0.4" x="2.5" y="7.5" width="15" height="1.5625" fill="#606174" />
            <path
                d="M2.76364 5.75755C2.56088 6.16334 2.51406 6.66415 2.50325 7.5H17.4968C17.4859 6.66415 17.4391 6.16334 17.2364 5.75755C16.9944 5.27327 16.6017 4.88062 16.1174 4.63864C15.5898 4.375 14.9015 4.375 13.525 4.375H6.475C5.09845 4.375 4.41018 4.375 3.88255 4.63864C3.39827 4.88062 3.00562 5.27327 2.76364 5.75755Z"
                fill="currentColor"
            />
            <path
                d="M17.5 9.0625H2.5V11.65C2.5 13.0265 2.5 13.7148 2.76364 14.2424C3.00562 14.7267 3.39827 15.1194 3.88255 15.3614C4.41018 15.625 5.09845 15.625 6.475 15.625H13.525C14.9015 15.625 15.5898 15.625 16.1174 15.3614C16.6017 15.1194 16.9944 14.7267 17.2364 14.2424C17.5 13.7148 17.5 13.0265 17.5 11.65V9.0625Z"
                fill="currentColor"
            />
        </svg>
    ),
    members: (
        <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.65"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.42446 12.1002C8.5445 12.8434 8.05487 13.7601 8.05487 14.537C8.05487 15.0451 8.41578 15.461 9.00655 15.7847C6.32573 16.2874 2 15.8407 2 14.5259C2 13.169 3.76184 11.3033 6.54116 11.3033C7.69452 11.3033 8.67384 11.6258 9.42446 12.1002ZM8.7207 7.81095C8.7207 9.14133 7.73 10.1802 6.54116 10.1802C5.35232 10.1802 4.36697 9.14133 4.36697 7.81625C4.36162 6.52827 5.36303 5.5 6.54116 5.5C7.72465 5.5 8.7207 6.51767 8.7207 7.81095Z"
                fill="currentColor"
            />
            <path
                d="M13.3334 9.54673C14.7515 9.54673 15.9332 8.32119 15.9332 6.75176C15.9332 5.22609 14.7451 4.02556 13.3334 4.02556C11.9281 4.02556 10.7337 5.2386 10.7401 6.75801C10.7401 8.32119 11.9154 9.54673 13.3334 9.54673ZM18.7501 14.59C18.7501 12.9893 16.6422 10.7883 13.3334 10.7883C10.0183 10.7883 7.91675 12.9893 7.91675 14.59C7.91675 17.3589 18.7501 17.3589 18.7501 14.59Z"
                fill="currentColor"
            />
        </svg>
    ),
};

const Style = styled.div<StyleProps>`
    display: flex;
    align-items: center;
    transition: background-color ${p => p.theme.transitionBase};
    padding: 4px 12px;
    height: 32px;
    margin: 2px 0 0;
    border-radius: 9px;

    h4 {
        margin-left: 12px;
        color: ${p => p.theme.textPale};
        font-size: 13px;
        font-weight: 400;
        flex-grow: 1;
        transition: all ${p => p.theme.transitionBase};
    }

    .count {
        font-size: 11px;
        color: ${p => p.theme.textXpale};
    }

    svg {
        color: ${p => p.theme.iconBase};
    }

    &:hover {
        background-color: ${p => p.theme.n100A};

        h4 {
            color: ${p => p.theme.textBase};
        }
    }

    &.active {
        background-color: ${p => p.theme.b100};

        h4 {
            font-weight: 600;
            color: ${p => p.theme.textAccent};
        }

        .count {
            color: ${p => p.theme.b400};
            opacity: 0.75;
        }

        svg {
            color: ${p => p.theme.b400};
        }
    }
`;

export const OrgSubtitleSidebarItem = (props: Props) => {
    const { active = false, label, onClick, count = 0, icon } = props;
    return (
        <Style className={active ? "active" : undefined} active={active} onClick={onClick}>
            {icons[icon]}
            <h4>{label}</h4>
            {count > 0 && <div className="count">{count}</div>}
        </Style>
    );
};
